export default __webpack_public_path__ + "static/autoklaw_mini-5f5780286a40c15f6c555e94e4395056.jpg";